export default __webpack_public_path__ + "static/media/character-yoshihi.b7821b85.png";